import { StateCreator } from 'zustand';
import { TaskNotification } from '../../types/notification';

export interface NotificationSlice {
  notifications: TaskNotification[];
  addNotification: (notification: TaskNotification) => void;
  markAsRead: (notificationId: string) => void;
  getUnreadCount: () => number;
  getUserNotifications: (userId: string) => TaskNotification[];
}

export const createNotificationSlice: StateCreator<NotificationSlice> = (set, get) => ({
  notifications: [],

  addNotification: (notification) => {
    set((state) => ({
      notifications: [notification, ...state.notifications]
    }));
  },

  markAsRead: (notificationId) => {
    set((state) => ({
      notifications: state.notifications.map(notif =>
        notif.id === notificationId ? { ...notif, read: true } : notif
      )
    }));
  },

  getUnreadCount: () => {
    return get().notifications.filter(n => !n.read).length;
  },

  getUserNotifications: (userId) => {
    return get().notifications.filter(n => n.assignedBy === userId);
  }
});